import SectionSharedFlightCard from './SectionSharedFlightCard';
export default SectionSharedFlightCard;
